
export const formatPrice = (price) => {
    if (price === undefined || price === null) {
      return 'Model';
    }
    if(price < 2){
      return 'Contact';
    }
    if (price >= 1000000) {
      const millionPrice = (price / 1000000).toFixed(1);
      return millionPrice.endsWith('.0') ? `${Math.round(price / 1000000)}M` : `${millionPrice}M`;  // Remove .0 for whole numbers
    } else if (price >= 1000) {
      const thousandPrice = (price / 1000).toFixed(1);
      return thousandPrice.endsWith('.0') ? `${Math.round(price / 1000)}K` : `${thousandPrice}K`;  // Remove .0 for whole numbers
    }
    return `${price}`;
  };


  export const formatAddress= (address) => {
    if (address === undefined || address === null) {
      return ' . ';
    }
    if(address.includes("null") || address.includes("null,")){
      address = address.replaceAll("null,", "").replaceAll("null", "").replaceAll(/(,,)+/g, ", ");
    }else{
      address = address.replaceAll(/(,,)+/g, ", ");
    }
    address = address.replaceAll(/(,)+/g, ", ");
    return address;
  };

  export const formatNumber = (number) => {
    if (number === undefined || number === null || number <= 0) {
      return '0.0';
    }
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(number);
  };
  
  export const priceMaker = (number) => {
    if (number === undefined || number === null || number <= 1) {
      return 'Contact';
    }
    return new Intl.NumberFormat('en-US').format(number);
  };

  export const formatPriceFull = (hitDoc) => {
    if (hitDoc.data.mlsListingPrice === undefined || hitDoc.data.mlsListingPrice === null || hitDoc.data.mlsListingPrice <= 1) {
      return `<a style="color:rgb(10, 81, 126);" target="_blank" href="/home/en/${hitDoc.data.propertyInfo.address.state}/${hitDoc.data.propertyInfo.address.city}/${hitDoc.main.publicId}">Contact Us for Price</a>`;
    }
    return "$"+ new Intl.NumberFormat('en-US').format(hitDoc.data.mlsListingPrice);
  };

  /**
   * Build JSON from array of objects which are in dot notation
   * setValueByPath
   * @param {*} arr 
   * @returns 
   */
  export const buildJsonByPath = (arr) => {
    const result = {};
  
    arr.forEach(item => {
      if(!item) return;
      const [path, value] = Object.entries(item)[0];
      const keys = path.split(".");
  
      let current = result;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          // Try to parse value
          try {
            current[key] = JSON.parse(value);
          } catch {
            current[key] = value;
          }
        } else {
          current[key] = current[key] || {};
          current = current[key];
        }
      });
    });

    return result;
  }